import React from "react";
import PropTypes from "prop-types";

const PartnersBannerPartner = ({ partner, index }) => {
	const { partnerThumbnail, partnerTitle, partnerUrl } = partner;
	return (
		<a
			className="partners-banner__container__marquee__partner"
			href={partnerUrl}
			target="_blank"
			rel="noopener noreferrer"
			style={{ animationDelay: `${index * 200}ms` }}
			aria-label={`Visit ${partnerTitle}`}
		>
			<img src={partnerThumbnail} alt={partnerTitle} />
		</a>
	);
};

PartnersBannerPartner.propTypes = {
	partner: PropTypes.shape({
		partnerThumbnail: PropTypes.string.isRequired,
		partnerTitle: PropTypes.string.isRequired,
		partnerUrl: PropTypes.string.isRequired,
	}),
	index: PropTypes.number,
};

export default PartnersBannerPartner;
